
import { gql } from '@apollo/client';

export const REFRESH_MUTATION = gql`
    mutation Refresh($refreshToken: String!) {
        refresh(refreshToken: $refreshToken) {
            success
            refreshToken
            token
        }
    }
`;
